import { SVGProps, Ref, forwardRef } from 'react';

export const ClockFilledSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 .5C1.875.5.5 3.25.5 6s1.375 5.5 5.5 5.5 5.5-2.75 5.5-5.5S10.125.5 6 .5m.45 2.3h-.9v3.465l2.875 1.597.437-.787-2.412-1.34z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ClockFilledSize12Glyph.displayName = 'ClockFilledSize12Glyph';
